import { ActionTypeEnum } from './../ActionTypeEnum';

const snackbarAction = (payload) => ({
	type: ActionTypeEnum.snackbar,
	payload: Object.assign({}, !payload.open && { open: true }, payload),
});

const loadingAction = (payload) => ({
	type: ActionTypeEnum.loading,
	payload,
});

const messageAction = (payload) => ({
	type: ActionTypeEnum.messages,
	payload,
});

export { snackbarAction, loadingAction, messageAction };
